import { useReveal } from "../hooks/useReveal";

interface SectionHeadProps {
  eyebrow: string;
  title: string;
  sub?: string;
}

/** Centered section header that floats up into view on scroll. */
export function SectionHead({ eyebrow, title, sub }: SectionHeadProps) {
  const reveal = useReveal();
  return (
    <div className="section-head" ref={reveal}>
      <span className="eyebrow">{eyebrow}</span>
      <h2 className="section-title">{title}</h2>
      {sub && <p className="section-sub">{sub}</p>}
    </div>
  );
}
